var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tab',{attrs:{"index":_vm.tab,"loginRequired":_vm.loginRequired,"iframeDisplay":true,"init":_vm.init}})
}
var staticRenderFns = []

export { render, staticRenderFns }